import React from 'react';

export default function PetCountIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Paw pad */}
      <ellipse cx="12" cy="16" rx="4" ry="3.5" fill={color} opacity="0.8" />
      {/* Toes */}
      <ellipse cx="7.5" cy="10" rx="2" ry="2.5" fill={color} opacity="0.8" />
      <ellipse cx="16.5" cy="10" rx="2" ry="2.5" fill={color} opacity="0.8" />
      <ellipse cx="10" cy="7.5" rx="1.8" ry="2.2" fill={color} opacity="0.8" />
      <ellipse cx="14" cy="7.5" rx="1.8" ry="2.2" fill={color} opacity="0.8" />
    </svg>
  );
}
